import image1 from './BG1.jpg';
import image2 from './BG2.jpg';
import image3 from './BG3.jpg';
import image4 from './BG4.jpg';
import image5 from './BG5.jpg';
import image7 from './BG7.png';
import image8 from './BG8.jpg';
import image9 from './BG9.jpg';
import image10 from './BG10.jpg';
import image11 from './BG11.jpg';
import image12 from './BG12.jpg';
import image13 from './BG13.jpg';

const images = [image1, image2, image3, image4, image5, image7, image8, image9, image10, image11, image12, image13];

export default {
	getNewImage: (imgArr = images, min = 0, max = 11) => {
		let minAct = Math.ceil(min);
		let maxAct = Math.floor(max);
		const rand = Math.floor(Math.random() * (maxAct - minAct + 1)) + minAct;

		return imgArr[rand];
	}
};
